<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>Schlagzeile</h3>
    {{videotextVorhersageBericht?.schlagzeile}}
  </div>
  <div class="bericht-text-container">
    <h3>Wetterlage</h3>
    {{videotextVorhersageBericht?.wetterlage}}
  </div>
  <div class="bericht-text-container">
    <h3>Vorhersagen</h3>
    <ng-container *ngFor="let v of videotextVorhersageBericht?.vorhersagen?.vorhersageListe">
      <span class="bericht-text-sub-label">{{v.beschreibung}} - {{v.datum | date: 'EEE dd.MM'}}</span>
      {{v.text}}
      <span class="bericht-text-sub-label">Wind</span>
      {{v.wind}}
    </ng-container>
  </div>
  <div class="bericht-text-container">
    <h3>Aussichten</h3>
    <ng-container *ngFor="let aussichtTag of videotextVorhersageBericht?.aussichten?.aussichtsListe">
      <span class="bericht-text-sub-label">{{aussichtTag.datum | date: 'EEE dd.MM'}}</span>
      {{aussichtTag.text}} Sonnenscheindauer: {{aussichtTag.sonnenscheinDauer}},
      Niederschlagswahrscheinlichkeit: {{aussichtTag.niederschlagsWahrscheinlichkeit}},
      Tiefstwerte: {{aussichtTag.tiefstwerteBis}} - {{aussichtTag.tiefstwerteVon}}
    </ng-container>
  </div>
</div>
